import React, { useMemo } from 'react';
import { useCompany } from '../../contexts/CompanyContext';
import { getGreeting } from '../../utils/timeOfDay';

interface WelcomeHeaderProps {
  className?: string;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ className }) => {
  const { userName, loading: userDetailsLoading } = useCompany();

  const userFirstName =
    !userDetailsLoading && userName ? userName.split(' ')[0] : '';

  const greeting = useMemo(() => {
    const base = getGreeting();
    const name = userDetailsLoading
      ? ''
      : userFirstName
        ? `, ${userFirstName}`
        : '';
    return `${base}${name}`;
  }, [userFirstName, userDetailsLoading]);

  const dateText = new Date()
    .toLocaleDateString('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
    })
    .toUpperCase();

  return (
    <div className={`welcome-header${className ? ` ${className}` : ''}`}>
      <span className='welcome-header-date'>{dateText}</span>
      <h1 className='welcome-header-greeting'>{greeting}</h1>
    </div>
  );
};

export default WelcomeHeader;
